interface NotifyAttendeesRequest {
    subject: string;
    content: string;
}

interface NotifyAttendeesSMSRequest {
    message: string;
}

interface NotifyAttendeesResponse {
    message: string;
}

export const notifyAttendeesService = {
    /**
     * Send an email to all attendees of an event
     * @param eventUuid - The UUID of the event
     * @param data - The email subject and content
     * @returns Promise with the response message
     */
    notifyAttendees: async (eventUuid: string, data: NotifyAttendeesRequest): Promise<NotifyAttendeesResponse> => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/events/notify/${eventUuid}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            credentials: 'include',
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error("Error sending emails. Please try again.");
        }

        return response.json();
    },

    /**
     * Send an SMS to all attendees of an event
     * @param eventUuid - The UUID of the event
     * @param data - The SMS message
     * @returns Promise with the response message
     */
    notifyAttendeesSMS: async (eventUuid: string, data: NotifyAttendeesSMSRequest): Promise<NotifyAttendeesResponse> => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/events/notify-sms/${eventUuid}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json"
            },
            credentials: 'include',
            body: JSON.stringify(data)
        });

        if (!response.ok) {
            throw new Error("Error sending SMS messages. Please try again.");
        }

        return response.json();
    }
}; 